module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Dickson lives in South Yorkshire with her retired farm manager husband. On leaving school she entered the nursing profession, which she left to bring up a young family. Having moved out of the chaotic farmhouse, she has more time to indulge in her favourite pastimes. She enjoys being outdoors, travelling, reading and music. An incurable romantic, she writes for pleasure. It was a love of history that drove her to writing historical romantic fiction."), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AV7YRB/tc-custom/9781460381199.jpg?1705201883758",
      "alt": "This image is the cover for the book Lucy Lane and the Lieutenant"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lucy Lane and the Lieutenant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A dangerous mission; a passionate past "), _c('br'), _c('br'), _vm._v("Nathan Rochefort never understood why his ex-fiancée, Lucy Lane, broke off their engagement. But now, faced with a treacherous mission, he needs her skills more than ever "), _c('br'), _c('br'), _vm._v("Lucy had put her handsome officer and his betrayal firmly behind her. Until Nathan explodes back into her life, a fierce reminder of all the hopes and dreams she once held dear. "), _c('br'), _c('br'), _vm._v("In the depths of the Portuguese mountains, Lucy and Nathan succumb to the intensity of their feelings, little realizing that the consequences of one stolen night will link them togetherfor always.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0